import CheckCircle from "@mui/icons-material/CheckCircle";
import Import from "assets/img/svg/import";
import Sage from "assets/img/svg/sageIcon";
import Upload from "assets/img/svg/upload";
import { Spinner } from "components/shared/Spinner";
import TrackedButton from "containers/TrackedButton";
import { useTranslation } from "react-i18next";

import { FileButton } from "../../MultiStep/ImportFile";

interface SageUploadResultPayload {
    id: number;
    fileName: string;
}

interface SageUploadStatusProps {
    isUploading: boolean;
    result: SageUploadResultPayload | null;
    onClick: () => void;
    sendLabel: string;
    successLabel: string;
    onDownload?: (id: number, fileName: string) => void;
}

// Displays Sage upload button or success state once upload is done
const SageUploadStatus = ({
    isUploading,
    result,
    onClick,
    sendLabel,
    successLabel,
    onDownload,
}: SageUploadStatusProps) => {
    const [t] = useTranslation();

    return (
        <TrackedButton action="payments-sage-upload">
            <div className="step-button-file">
                {result ? (
                    <div
                        className="sage-upload-success"
                        onClick={(e) => {
                            if (onDownload) {
                                e.stopPropagation();
                                onDownload(result.id, result.fileName);
                            }
                        }}
                        style={onDownload ? { cursor: "pointer" } : {}}
                        title={onDownload ? t("PaymentModal.SageHistory.DownloadFile") : undefined}
                    >
                        <div className="sage-upload-success-header">
                            <CheckCircle className="sage-upload-success-icon" />
                            <span className="sage-upload-success-text">{successLabel}</span>
                        </div>
                        <div className="sage-upload-success-footer">
                            <span className="sage-upload-success-filename">{result.fileName}</span>
                            {onDownload && (
                                <div className="sage-upload-success-download-icon">
                                    <Import width="14" height="14" color="#004e31" />
                                </div>
                            )}
                        </div>
                    </div>
                ) : isUploading ? (
                    <div className="sage-upload-loading">
                        <Spinner />
                        <span className="sage-upload-loading-text">{t("PaymentModal.SageUploadPending")}</span>
                    </div>
                ) : (
                    <FileButton
                        label={sendLabel}
                        onClick={onClick}
                        buttonColor="white"
                        disabled={isUploading}
                        leftIcon={<Sage className="sage-file-icon" />}
                        rightIcon={<Upload />}
                    />
                )}
            </div>
        </TrackedButton>
    );
};

export type { SageUploadResultPayload, SageUploadStatusProps };
export default SageUploadStatus;
